export default "__VITE_ASSET__NaOLAODI__"